export default __webpack_public_path__ + "static/Apps_y_Videojuegos-interactivos-Mexico3-1706118927a59c58873a44d2a93ccfd7.jpg";